import {ParsedUrlQuery} from 'querystring'

export default function getQueryParam({query, key}: {query: ParsedUrlQuery; key: string}) {
  const value = query[key]
  if (!value) return
  return value
}
